import {SpriteIconsType} from "@components/SpriteIcon";

import {SocialProofDetailsItem, SocialProofType} from "./interfaces";

export const getSocialProofDetails = (
  proofType: SocialProofType,
  companyName = "your company"
): SocialProofDetailsItem => {
  const detailedSocialProofs = {
    [SocialProofType.MostPopular]: {
      icon: SpriteIconsType.Fire,
      name: "Popular in your office",
      description: "Popular in your office",
      longDescription: `Eaters at ${companyName} have ordered this dish more than any other on this day!`,
    },
    [SocialProofType.MostFavorite]: {
      icon: SpriteIconsType.HeartExplodeLong,
      name: "Office favorite",
      description: "Office favorite",
      longDescription: `Eaters at ${companyName} have favorited this dish more than any other on this day!`,
    },
    [SocialProofType.HighestRating]: {
      icon: SpriteIconsType.Star,
      name: "Coworker approved",
      description: "Coworker approved",
      longDescription: `Eaters at ${companyName} have rated this dish higher than any other on this day!`,
    },
  };

  return detailedSocialProofs[proofType];
};
